import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables, palette,breakpoints }) => ({
  howItWorksContent: {
    margin: '0 auto',
    [breakpoints.down('xs')]: {
      width: '98vw',
      overflow: 'hidden'
    },
    '& .title-icon': {
      color: palette.jet?.supportBrand01,
      marginRight:variables?.spacingC
    },
    '& .howitworks-title':{
      marginBottom:variables?.spacingC
    },
    '& .howitworks-description': {
      [breakpoints.down('xs')]:{ 
        width: '100%',
       
      },
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: variables?.spacingI,
    },
    '& .howitworks-videos-container': {
        width:'921px',
        [breakpoints.down('md')]: {
          width:'auto'
        },  
        [breakpoints.down('xs')]:{ 
          width: '100%',
          display:'unset',
        },
        margin:'0 auto',
        display:'flex',
        justifyContent:'space-around',
        '& .howitworks-video-item':{
          '& .play-button': {
            width: '45px',
            height: '45px',
            position: 'absolute',
            top: '40px',
            zIndex:1,
            [breakpoints.down('xs')]:{ 
              top:'45px',
              width: '66px',
              height: '66px',
            },
          },
          cursor:'pointer',
          position:'relative',
          width:'213px',
          // height:'175px',
          display: 'flex !important',
          alignItems: 'center',
          flexDirection: 'column',
          '& p':{
            color:palette?.jet?.contentBrand,
            paddingLeft:variables?.spacingB,
            paddingRight:variables?.spacingB,
            position: 'absolute',
            width: '52%',
            textAlign: 'left',
            display: 'flex',
            top: '0px',
            left: variables?.spacingB,
            height: '120px',
            alignItems: 'center',
            fontWeight:'bold',
            fontSize:'14px',
            [breakpoints.down('xs')]: {
              left: variables?.spacingD,
              width: '50%'
            },
          },
          '& img':{ 
            borderRadius:variables?.radiusRoundedC,
            width:'213px',
            height:'120px',
            [breakpoints.down('xs')]: {
              width:'70vw',
              height:'unset'
            },
            marginBottom:variables?.spacingC
          }
        }
    }
  },
}));

export default useStyles;
